import CourseModulesView from './components/modules-view';

export default CourseModulesView;
